import { Outlet } from 'react-router-dom';
import { useGetProjectDataQuery } from '@/entities/layout';
import { useProjectSiteParams } from '@/shared/lib';

export const ProjectSiteLoader = () => {
  const { projectId, siteId, isValid } = useProjectSiteParams();

  const { isLoading, error } = useGetProjectDataQuery(
    { projectId, siteId },
    {
      skip: !isValid || !projectId || !siteId
    }
  );

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p>Loading project data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center text-destructive">
          <p>Failed to load project data</p>
          <p className="text-sm text-muted-foreground mt-1">Please check the URL or try refreshing</p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
